/* tslint:disable */
/* eslint-disable */
/**
 * Tractable Identity Broker API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PasswordPolicy } from './PasswordPolicy';
import {
    PasswordPolicyFromJSON,
    PasswordPolicyFromJSONTyped,
    PasswordPolicyToJSON,
} from './PasswordPolicy';

/**
 * 
 * @export
 * @interface UserPoolResponse
 */
export interface UserPoolResponse {
    /**
     * 
     * @type {PasswordPolicy}
     * @memberof UserPoolResponse
     */
    passwordPolicy: PasswordPolicy;
}


/**
 * Check if a given object implements the UserPoolResponse interface.
 */
export function instanceOfUserPoolResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "passwordPolicy" in value;

    return isInstance;
}

export function UserPoolResponseFromJSON(json: any): UserPoolResponse {
    return UserPoolResponseFromJSONTyped(json, false);
}

export function UserPoolResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserPoolResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'passwordPolicy': PasswordPolicyFromJSON(json['passwordPolicy']),
    };
}

export function UserPoolResponseToJSON(value?: UserPoolResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'passwordPolicy': PasswordPolicyToJSON(value.passwordPolicy),
    };
}

